import { createSlice } from '@reduxjs/toolkit'

type Steps = {
  step1: boolean,
  step2: boolean,
  step3: boolean,
}

const initialState: Steps = {
  step1: false,
  step2: false,
  step3: false
}

const OnboardingStepSlice = createSlice({
  name: 'onboardingStep',
  initialState,
  reducers: {
    onboardingStep: (state, action) => {
      state.step1 = action.payload.step1
      state.step2 = action.payload.step2
      state.step3 = action.payload.step3
    },
  },
})

export const { onboardingStep } = OnboardingStepSlice.actions

export default OnboardingStepSlice.reducer
